import { useContext } from 'react';
import {
  FeatureFlagContext,
  FeatureFlagState,
} from 'src/components/featureFlags/FeatureFlagProvider';

const useFeatureFlags = (): FeatureFlagState => useContext(FeatureFlagContext);

export default useFeatureFlags;
